import { getVipCasino, getBaste, getCasino, getCasinoSlot, getVirtual, getLiveCasino, getAllGames } from "../../js/api/accountBalance.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

const nonSportTypes = ['casino', 'casino-slots', 'virtual', 'aviator'];

export class AccountBalanceTable {
  constructor({root, type, startDate, endDate, userId, isOpen}) { 
    this.root = $(root);
    this.type = type;
    this.typeId = type.toLowerCase().replace('/', '-').replace(' ', '-');

    this.startDate = startDate;
    this.endDate = endDate;

    this.userId = userId;
    this.role = localStorage.getItem('role');
    this.username = localStorage.getItem('username');
    this.isOpen = isOpen;

    this._initRender(isOpen);
  }

  _initRender(isOpen) {
    this.wrapperId = `accountBalanceTbl_${this.typeId}`;
    let view = `
      <div id="${this.wrapperId}" class="groupWrapper">
        <div class="accountBalanceContentHeader m-t-6 table-header">
            <span>${_t(this.type).toUpperCase().replace('/', ' ')}</span>
        </div>
        <div class="table-content"></div>
      </div>
    `

    this.root.append(view);
    setTimeout(() => {
      this.wrapper = this.root.find(`#${this.wrapperId}`);
      this.content = this.root.find('#accountBalanceTbl_' + this.typeId + ' .table-content');
      if (isOpen) this._fetchDataAndRender();

      const that = this;
      this.wrapper.find('.accountBalanceContentHeader').on('click', () => {
        debugger;
        if (that.isOpen) {
          that.wrapper.addClass('clicked');
        } else {
          that.wrapper.removeClass('clicked');
          if (that.haveChanges || that.content.text().length === 0) that._fetchDataAndRender();
        }
        that.isOpen = !that.isOpen;
      });
    }, 500);
  } 

  async _fetchDataAndRender() {
    this.content.html(`
      <div class="accountBalanceRow fiveColumnsHolder">
        <span style="width: 100%">${_t('Loading...Please wait!')}</span>
      </div>
    `);
    const fetchBody = { role: this.role, startDate: this.startDate, endDate: this.endDate, userId: this.userId };
    let response;
    switch (this.type.toLowerCase()) {
      case 'baste':
        response = await getBaste(fetchBody);
        break;
      case 'all games':
        response = await getAllGames(fetchBody);
        break;
      case 'casino':
        response = await getCasino(fetchBody);
        break;
      case 'live/casino':
        response = await getLiveCasino(fetchBody);
        break;
      case 'deluxe':
        response = await getCasinoSlot(fetchBody);
        break;
      case 'virtual':
        response = await getVirtual(fetchBody);
        break;
      case 'vip/casino':
        response = await getVipCasino(fetchBody);
        break;
            
    }

    let data = [];
    if (response && response.success === 'OK') {
      data = response.data;
    }

    if (!data.length) {
      this.content.html(`
        <div class="accountBalanceRow fiveColumnsHolder">
          <span style="width: 100%">${_t('No data available')}</span>
        </div>
      `);
      return;
    }

    const totals = [];
    const addToTotals = (currency, stake, win, percentage, jackpot, difference) => {
      const index = totals.findIndex(i => i.currency === currency);
      if (index === -1) {
        totals.push({
          currency: currency,
          stake: parseFloat(stake ?? 0),
          win: parseFloat(win ?? 0),
          percentage: parseFloat(percentage ?? 0),
          jackpot: parseFloat(jackpot ?? 0),
          difference: parseFloat(difference ?? 0)
        })
      } else {
        totals[index].stake += parseFloat(stake ?? 0);
        totals[index].win += parseFloat(win ?? 0);
        totals[index].percentage += parseFloat(percentage ?? 0);
        totals[index].jackpot += parseFloat(jackpot ?? 0);
        totals[index].difference += parseFloat(difference ?? 0);
      }
    }

    const formatNumber = (value, currency) => {
      if (!value || value.length === 0) return '-';
      if (currency) currency = currency.slice(0, 3);

      return Utils.formatNumber(value, currency);
    }

    const view = `
      <div class="accountBalanceContent">
        <div class="accountBalanceContentHeader whiteColor fiveColumnsHolder">
            <span style="width:19%;">${_t('Info')}</span>
            <span style="width:16%;">${_t('Xhiro')}</span>
            <span style="width:16%;">${_t('Fitimi')}</span>
            ${nonSportTypes.some(t => t === this.typeId) ? `<span>${_t('Jackpot')}</span>` : '<span>%</span>'}
            <span style="width:16%;">${_t('Diferenca')}</span>
        </div>
      </div>
      ${
        data.map(item => {
          addToTotals(item.curr_name, item.stake, item.win, item.percentage, item.jackpot, item.difference)

          return `
            <div class="accountBalanceRow fiveColumnsHolder" type="${this.type.toLowerCase()}" user-id="${item.user_id ? item.user_id : item.id}" role="${item.role_name}" start-date="${this.startDate}" end-date="${this.endDate}">
              <span>${item.username ?? this.username}</span>
              <span>${formatNumber(item.stake)}</span>
              <span>${formatNumber(item.win)}</span>
              <span>${formatNumber(nonSportTypes.some(t => t === this.typeId) ? item.jackpot : item.percentage)}</span>
              <span>${formatNumber(item.difference, item.curr_name)}</span>
            </div>
          `
        }).join('')
      }
      ${ totals.map(item => {
        return `
          <div class="accountBalanceContentHeader whiteColor fiveColumnsHolder">
            <span>Total ${item.currency}</span>
            <span>${formatNumber(item.stake)}</span>
            <span>${formatNumber(item.win)}</span>
            <span>${formatNumber(nonSportTypes.some(t => t === this.typeId) ? item.jackpot : item.percentage)}</span>
            <span>${formatNumber(item.difference, item.currency)}</span>
          </div>
          `;
        }).join('')}
    `;

    this.content.html(view);

    $('body').off('click', '.accountBalanceRow > span:first-child').on('click', '.accountBalanceRow > span:first-child', async function(e) {
      // debugger;
      const wrapper = $(this).closest('.accountBalanceRow');
      const wrapperWithDate = $(this).closest('.accountBalanceRow[start-date]');

      const type = wrapper.attr('type');
      const userId = wrapper.attr('user-id');
      const role = wrapper.attr('role');
      const startDate = wrapper.attr('start-date') ?? wrapperWithDate.attr('start-date');
      const endDate = wrapper.attr('end-date') ?? wrapperWithDate.attr('end-date');
      if (role === 'User') {
        return;
      }


      if(wrapper.hasClass('clicked')) {
        wrapper.find('.childrenItem').remove();
        wrapper.removeClass('clicked');
        return;
      }

      wrapper.addClass('clicked');
      
      wrapper.append(`
        <div class="childrenItem loading">
          <span style="width: 100%">${_t('Loading...Please wait!')}</span>
        </div>
      `);
      const fetchBody = {
        role: role,
        startDate: startDate,
        endDate: endDate,
        userId: userId
      }

      let response;
      
      switch (type.toLowerCase()) {
        case 'sport':
        case 'baste':
          response = await getBaste(fetchBody);
          break;
        case 'casino':
          response = await getCasino(fetchBody);
          break;
        case 'live/casino':
          response = await getLiveCasino(fetchBody);
          break;
        case 'deluxe':
          response = await getCasinoSlot(fetchBody);
          break;
        case 'virtual':
          response = await getVirtual(fetchBody);
          break;
        case 'vip/casino':
          response = await getVipCasino(fetchBody);
          break;    
      }

      if (response && response.success === 'OK' && response.data.length > 0) {
        const childrenContent = 
        response.data.map(item => {
          return `
            <div class="accountBalanceRow fiveColumnsHolder" type="${type.toLowerCase()}" user-id="${item.user_id ? item.user_id : item.id}" role="${item.role_name}">
              <span>${item.username ?? this.username}</span>
              <span>${formatNumber(item.stake)}</span>
              <span>${formatNumber(item.win)}</span>
              <span>${formatNumber(nonSportTypes.some(t => t === this.typeId) ? item.jackpot : item.percentage)}</span>
              <span>${formatNumber(item.difference, item.curr_name)}</span>
            </div>
            `
          }).join('');

        const childrenItem = wrapper.find('.childrenItem');
        childrenItem.html(childrenContent);
      } else {
        const childrenItem = wrapper.find('.childrenItem');
        childrenItem.html(`
          <div class="accountBalanceRow fiveColumnsHolder">
            <div class="accountBalanceRow fiveColumnsHolder">
              <span style="width: 100%">${_t('No data available')}</span>
            </div>
          </div>
        `);
      }
    })
  }

  setDate(startDate, endDate) {
    this.startDate = startDate;
    this.endDate = endDate;
    if (this.isOpen) this._fetchDataAndRender();
    else (this.haveChanges = true)
  }

  setCurrency(currency) {
    this.currency = currency;
    if (this.isOpen) this._fetchDataAndRender();
    else (this.haveChanges = true)
  }

  setUserId(userId) {
    this.userId = userId;
    if (this.isOpen) this._fetchDataAndRender();
    else (this.haveChanges = true)
  }
}
